import { PIMFormikCheckbox } from './PIMFormikCheckbox';

export default PIMFormikCheckbox;
